/** @jsx jsx */

import React, {
  Fragment as _,
  createContext,
  useLayoutEffect,
  useState,
} from 'react';
import { css, jsx } from '@emotion/core';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Box } from '@chameleoncreator/creator-ui';
import useImageLoader from 'hooks/useImageLoader';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import { useDispatch } from 'react-redux';

const Background = ({ background, backgroundImageOpacity }) => {
  const imgLoadedState = useImageLoader(
    background ? background.split(/\(|\)/g)[1] : ''
  );

  const opacity = backgroundImageOpacity / 100;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        ...(background && {
          background: `url('${background}') no-repeat`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }),
        // ...(background && background.includes('url')
        //   ? {
        //       background,
        //       opacity: imgLoadedState === 2 ? 1 : 0,
        //       transition: 'opacity 1s',
        //     }
        //   : {
        //       background,
        //       transition: 'background 0.35s',
        //     }),
        opacity,
        pointerEvents: 'none',
      }}
    />
  );
};

// could / would / should put this in the store / redux
interface IAssessmentContext {
  assessmentId: string;
  submitted: {
    [id: string]: {
      answer: string[];
      correctAnswer: string[];
      isCorrect: boolean | undefined;
      attemptCount: number;
    };
  };
  resetQuestion: (id: string) => void;
  setSubmitted: (
    id: string,
    answer: string[],
    correctAnswer: string[],
    isCorrect: boolean
  ) => void;
  maxAttempts: undefined | number;
  answersWrappingAlignment?: string;
  saveData?: boolean;
  learnMoreResetsAssessment?: boolean;
}

const AssessmentContext = createContext<IAssessmentContext>({
  assessmentId: '',
  submitted: {},
  resetQuestion: () => {},
  setSubmitted: () => {},
  maxAttempts: undefined,
  answersWrappingAlignment: 'center',
  saveData: false,
  learnMoreResetsAssessment: false,
});

const AssessmentContainer = props => {
  const { state, topic: assessment, children } = props as any;

  //
  const {
    maxAttempts,
    answersWrappingAlignment,
    saveData = false,
    learnMoreResetsAssessment = false,
  } = assessment?.props;

  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState<{
    [id: string]: {
      answer: string[];
      correctAnswer: string[];
      isCorrect: boolean;
      attemptCount: number;
    };
  }>({});

  const block: any = getBlockById(assessment.id);

  let {
    sId,
    src,
    backgroundImage,
    backgroundImageOpacity = 100,
  }: any = getBlockById(assessment.id).props;

  // dirty gotta try and cover for legacy backgroundImage
  if (src) {
    backgroundImage = src;
  }

  const backgroundColor =
    block.props.backgroundColor || state.theme.backgroundColor || '';

  const textColor = block.props.textColor || state.theme.textColor || '';

  const opacity = backgroundImageOpacity / 100;

  return (
    <AssessmentContext.Provider
      value={
        {
          assessmentId: assessment.id,
          submitted,
          resetQuestion(id: string) {
            const updatedSubmissions = JSON.parse(JSON.stringify(submitted));
            delete updatedSubmissions[id];

            setSubmitted(updatedSubmissions);
            //
          },
          setSubmitted(
            id: string,
            answer: string[],
            correctAnswer: string[],
            isCorrect: boolean
          ) {
            return;

            // move all this into the question itself since using state

            const attemptCount = submitted[id] ? submitted[id].attemptCount : 0;

            dispatch(
              updateAssessmentAction({
                assessmentId: assessment.id,
                questionData: {
                  [id]: {
                    answer,
                    correctAnswer,
                    isCorrect,
                    attemptCount: attemptCount + 1,
                  },
                },
              })
            );

            setSubmitted({
              ...submitted,
              [id]: {
                answer,
                correctAnswer,
                isCorrect,
                attemptCount: attemptCount + 1,
              },
            });
          },
          maxAttempts,
          answersWrappingAlignment,
          saveData,
          learnMoreResetsAssessment,
        } as IAssessmentContext
      }
    >
      <Box
        className="fader_-5s"
        id="main"
        tabindex="-1"
        css={css`
          position: relative;
          // width: 100vw;
          // height: 100vh;
          background: ${backgroundColor};
        `}
      >
        <Background
          background={backgroundImage}
          backgroundImageOpacity={backgroundImageOpacity}
        />

        {children}
      </Box>
    </AssessmentContext.Provider>
  );
};

export default AssessmentContainer;
export { AssessmentContext };
